import React, { useState, Fragment, useEffect } from 'react';
import {
  Row, Input, Button, Modal,
  ModalHeader, Label,
  ModalBody, ModalFooter
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';

import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { putAPI_Update_Response } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../gallery/index'
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
function ImgLink({
  reloadBotResponse,
  caption,
  url,
  code,
  messages,
  urls,
  captions,
  details,
  index,
  setIsEditingToFalse,
  setIsAddImageToFalse,
  isAddImage, data,
  /** Globle property id from redux */
  propertyId,
  apiButtons,
  SaveRecommenderQuestionCode,
  locale,
  selectedLang,
  historyUpdator
}) {
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [urlInput, setUrlInput] = useState(url || '');
  const [captionInput, setCaptionInput] = useState(caption || '');
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [inputData, setInputData] = useState({
    'data': data || [{
      url: '',
      caption: '',
    }]
  });
  const [indexval, setIndex] = useState(0);
  const [postData, setPostData] = useState({
    GroupId: getGroupID(),
    Code: code,
    Language: `${selectedLang === 'en' ? 'en-US' : selectedLang}`,
    Channel: 'WebsiteDirectLine',
    PropertyId: propertyId === "-1" ? null : propertyId,
    Default: null,
    Overrides: {},
    UserName: historyUpdator
  });

  const togglegallery = (val) => {
    setGalleryVisible(!galleryVisible);
    setIndex(val);
  };

  const selectedImage = (link) => {
    // inputData.data.map((i, index) => {
    //   if (index === indexval) {
    //     i.url = link.src;
    //     i.caption = link.caption;
    //   }
    // });

    let temp = inputData.data;
    temp.map((i, index) => {
      if (index === indexval) {
        i.caption = link.caption;
        i.url = link.src;
      }
    });
    setInputData({ ...inputData, data: temp });
    // setUrlInput(link.src)
    // setCaptionInput(link.caption)
  };

  useEffect(() => {
    //console.log('details', details);
    let imageList = [];
    setPostData(pre => {
      if (!isAddImage) {
        inputData.data.map(m => {
          if (m.url !== '') {
            let val = imageList.length > 0 ? imageList.length : 0;
            imageList[val] = { Url: '', Caption: '' };
            imageList[val].Url = m.url;
            imageList[val].Caption = m.caption;
          }
        });
      }
      if (isAddImage) {
        let idx = urls.length - 1;
        imageList = urls.map((url, index) => {
          const imgCaption = captions[index];
          return { Url: url, Caption: imgCaption };
        });
        // imageList[idx + 1] = { Url: '', Caption: '' };
        // imageList[idx + 1].Url = urlInput;
        // imageList[idx + 1].Caption = captionInput; 
        inputData.data.map(m => {
          if (m.url !== '') {
            let val = imageList.length > 0 ? imageList.length : 0;
            imageList[val] = { Url: '', Caption: '' };
            imageList[val].Url = m.url;
            imageList[val].Caption = m.caption;
          }
        });
        // console.log('object', idx); 
      }

      return {
        ...pre,
        Default: {
          Messages: messages,
          Images: imageList,
          apiButtons: apiButtons
        },
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlInput, inputData, captionInput]);

  const handleCaptionChange = (val, text) => {
    let temp = inputData.data;
    temp.map((i, index) => {
      if (index === val)
        i.caption = text;
    });
    setInputData({ ...inputData, data: temp });
  };

  const handleUrlChange = (val, text) => {
    let temp = inputData.data;
    temp.map((i, index) => {
      if (index === val)
        i.url = text;
    });
    setInputData({ ...inputData, data: temp });
  };
  const handleRemove = (val) => {
    let temp = inputData.data.filter((i, index) =>
      index !== val
    );
    setInputData({ ...inputData, data: temp });
  };

  const AddInput = () => {
    let temp = inputData.data;
    temp.push({
      url: '',
      caption: '',
    });
    setInputData({ ...inputData, data: temp });
  };
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={galleryVisible} toggle={togglegallery} style={{ maxWidth: '1000px' }}>
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image
                </ModalHeader>
                <ModalBody>
                  <ImageGallery propertyId={propertyId} selectedImage={selectedImage} togglegallery={togglegallery}
                    hideUserUploads={false} searchText={""} />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const handleSave = async () => {
    try {
      return await AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_Response}`,
        data: postData,
      })
        .then((res) => {
          if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
            && res.data.Messages !== null && res.data.Messages.length > 0) {
            setMsg(res.data.Messages);
            setOpen(true);
          }
          else {
            if (setIsEditingToFalse) {
              setIsEditingToFalse();
            }
            if (setIsAddImageToFalse) {
              setIsAddImageToFalse();
            }
            setTimeout(() => {
              if (SaveRecommenderQuestionCode !== undefined) {
                SaveRecommenderQuestionCode();
              }
              else {
                reloadBotResponse();
              }
            }, 1000);
          }
        });


    } catch (error) {
      console.error(error);
    }
  };

  const handleCancel = () => {
    if (setIsEditingToFalse) {
      setIsEditingToFalse();
    }
    if (setIsAddImageToFalse) {
      setIsAddImageToFalse();
    }
  };
  //console.log(inputData);
  return (
    <div>
      <Modal isOpen={true} style={{ maxWidth: '1000px', borderRadius: '25px' }}>
        <ModalHeader>
          Images
        </ModalHeader>
        <ModalBody>
          {inputData.data.map((m, index) => {
            return (
              <Fragment key={index}>
                <Row className='mb-2'>
                  <Colxx xxs="2">
                    <img
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      alt="room image"
                      src={
                        m.url || 'https://via.placeholder.com/150/'
                      }
                    />
                  </Colxx>
                  <Colxx xxs="8" className={m.url === "" ? "mt-4" : ''}>
                    <Row className='mb-2'>
                      <Colxx xxs="2" className='mt-2'>Caption</Colxx>
                      <Colxx xxs="9">
                        <Input
                          type="text"
                          value={m.caption}
                          onChange={(e) => { handleCaptionChange(index, e.target.value) }}
                        ></Input>
                      </Colxx>
                    </Row>
                    <Row>
                      <Colxx xxs="2" className='mt-2'> <IntlMessages id='dashboards.imagelink' /></Colxx>
                      <Colxx xxs="9">
                        <Input
                          type="text"
                          value={m.url}
                          onChange={(e) => { handleUrlChange(index, e.target.value) }}
                        ></Input>
                      </Colxx>
                    </Row>
                    {/* <Row>
                      <Colxx xxs="2">
                      </Colxx>
                      <Colxx xxs="8">
                        <div
                          className="float-left"
                          style={{ marginTop: ' 5px', marginBottom: '5px' }}
                        >
                          <Button color="primary" className="add-button" size="xs" onClick={() => togglegallery(index)}>
                            Browse Gallery
                          </Button>
                        </div>

                      </Colxx>
                    </Row> */}
                  </Colxx>
                  <Colxx xxs="1" className={m.url === "" ? "mt-4" : ''}>
                    <Label>Browse</Label>
                    <div
                      className="iconsminds-photo"
                      onClick={(event) => togglegallery(index)}
                      style={{
                        cursor: 'pointer',
                        fontSize: '28px',
                        color: '#73236b',
                      }}
                    ></div>
                  </Colxx>
                  <Colxx xxs="1" className={m.url === "" ? "mt-4" : ''}>
                    <Label>Remove</Label>
                    <Button
                      onClick={() => handleRemove(index)}
                      color="secondary"
                      size="xs"
                      outline
                      style={{ margin: '6px' }}
                    >
                      -
                    </Button>
                  </Colxx>
                </Row>
              </Fragment>);
          })
          }
          <Row>
            <Button
              onClick={AddInput}
              color="primary"
              size="xs"
              outline
              style={{ margin: '6px' }}
            >
              + Add image
            </Button>
          </Row>
        </ModalBody>
        <ModalFooter>
          <div
            className="float-right"
            style={{ marginTop: ' 5px', marginBottom: '5px' }}
          >
            <Button
              color="secondary"
              className="add-button"
              size="m"
              onClick={handleSave}
            >
              Save
            </Button>
            <b> </b>
            <Button
              color="light"
              className="add-button"
              size="m"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </div>
        </ModalFooter>
      </Modal >

      {ImageGalleryButton()}
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </div >
  );
}



const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps)(ImgLink));
